import { render, staticRenderFns } from "./orderDetailView.vue?vue&type=template&id=34d0dc34&scoped=true"
import script from "./orderDetailView.vue?vue&type=script&lang=js"
export * from "./orderDetailView.vue?vue&type=script&lang=js"
import style0 from "./orderDetailView.vue?vue&type=style&index=0&id=34d0dc34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d0dc34",
  null
  
)

export default component.exports